import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const s = {
    footer: { background: '#141210', borderTop: '1px solid rgba(255,255,255,0.06)', padding: '3rem 2rem 2rem', marginTop: '4rem' },
    inner: { maxWidth: 1160, margin: '0 auto' },
    top: { display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 1fr', gap: '3rem', marginBottom: '2.5rem', paddingBottom: '2.5rem', borderBottom: '1px solid rgba(255,255,255,0.06)' },
    logo: { fontFamily: 'Fraunces, serif', fontSize: '1.3rem', color: '#e8b86d', marginBottom: '0.65rem' },
    tagline: { fontSize: '0.82rem', color: 'rgba(255,255,255,0.35)', lineHeight: 1.7, marginBottom: '1rem' },
    colTitle: { fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: 'rgba(255,255,255,0.25)', fontWeight: 600, marginBottom: '1rem' },
    col: { display: 'flex', flexDirection: 'column', gap: '0' },
    link: { fontSize: '0.82rem', color: 'rgba(255,255,255,0.4)', textDecoration: 'none', padding: '0.3rem 0', display: 'block' },
    bottom: { display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem', fontSize: '0.75rem', color: 'rgba(255,255,255,0.2)' },
    payRow: { display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' },
    payLabel: { fontSize: '0.72rem', color: 'rgba(255,255,255,0.25)' },
    payPill: { fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: 5 },
  };

  return (
    <footer style={s.footer}>
      <div style={s.inner}>
        <div style={s.top}>
          <div>
            <div style={s.logo}>LayoffFund</div>
            <p style={s.tagline}>Helping laid-off people rise again — one campaign at a time. Founded by Santosh Pujeri.</p>
            <div style={s.payRow}>
              <span style={s.payLabel}>Payments via</span>
              <span style={{ ...s.payPill, background: 'rgba(103,114,229,0.15)', color: '#a0a8f0' }}>Stripe</span>
              <span style={{ ...s.payPill, background: 'rgba(26,115,232,0.15)', color: '#7aabf0' }}>UPI</span>
              <span style={{ ...s.payPill, background: 'rgba(0,156,222,0.15)', color: '#7acfe8' }}>PayPal</span>
            </div>
          </div>
          <div style={s.col}>
            <div style={s.colTitle}>Platform</div>
            <Link to="/campaigns" style={s.link}>Browse campaigns</Link>
            <Link to="/create-campaign" style={s.link}>Start a campaign</Link>
            <Link to="/#how" style={s.link}>How it works</Link>
          </div>
          <div style={s.col}>
            <div style={s.colTitle}>Company</div>
            <Link to="/#founder" style={s.link}>About us</Link>
            <a href="https://linkedin.com/in/santosh-pujeri" target="_blank" rel="noreferrer" style={s.link}>LinkedIn</a>
            <a href="https://github.com/pujerisantosh/layofffund" target="_blank" rel="noreferrer" style={s.link}>GitHub</a>
          </div>
          <div style={s.col}>
            <div style={s.colTitle}>Legal</div>
            <Link to="/privacy" style={s.link}>Privacy policy</Link>
            <Link to="/terms" style={s.link}>Terms of service</Link>
            <a href="mailto:16santoshpujari@gmail.com" style={s.link}>Contact us</a>
          </div>
        </div>
        <div style={s.bottom}>
          <span>© 2026 LayoffFund. Founded by Santosh Pujeri. All rights reserved.</span>
          <span>Made with ♥ in Bengaluru, India</span>
        </div>
      </div>
    </footer>
  );
}
